/// <reference path='common.ts' />
/// <reference path='element_bind.ts' />

/**
 * ページロード時の処理を行うクラスです。
 *
 * 属性
 * data-load-search: URLのクエリパラメータをdata-bindに設定する
 * data-load-search-arg: data-bindに設定する変数（省略時は展開される）
 * data-load-search-click: 先祖エレメントがクエリパラメータの設定を行った場合にクリックイベントを発生させる
 * data-loac-click: データロード時にクリックする
 */
class HaoriLoad {
  static bind: any = null;

  // ロード時のクリックキュー
  static clickQueue: Element[] = [];

  // 初期化の有無
  static init = false;

  /**
   * 対象エレメントもしくは子エレメントに対してクエリパラメータをdata-bind属性に設定します。
   *
   * @param element 対象エレメント
   */
  static bindSearch(element: Element) {
    if (!element.hasAttribute('data-load-search')) {
      return;
    }
    if (location.search.length <= 1) {
      return;
    }
    if (this.bind == null) {
      if (location.search.indexOf('=') >= 0) {
        let search = new URLSearchParams(location.search.substring(1));
        this.bind = {};
        search.forEach((value, key) => {
          let parts = key.split('.');
          let object: any = this.bind;
          for (let i = 0; i < parts.length - 1; i++) {
            let child = object[parts[i]];
            if (typeof child == 'undefined') {
              child = {};
              object[parts[i]] = child;
            }
            object = child;
          }
          object[parts[parts.length - 1]] = value;
        });
      } else {
        this.bind = decodeURI(location.search.substring(1));
      }
    }
    let object = new HashObject();
    if (element.hasAttribute('data-load-search-arg')) {
      let arg = <string>element.getAttribute('data-load-search-arg');
      object[arg] = this.bind;
    } else {
      object = this.bind;
    }
    element.setAttribute('data-bind', JSON.stringify(object));
    HaoriBind.bind(element);
    element.querySelectorAll('[data-load-search-click]').forEach((element) => {
      if (HaoriLoad.init) {
        element.dispatchEvent(
          new CustomEvent('click', {
            bubbles: true,
            cancelable: true,
            composed: true,
          })
        );
      } else {
        // まだ画面がロードされていないのでキューに入れる
        if (HaoriLoad.clickQueue.indexOf(element) < 0) {
          HaoriLoad.clickQueue.push(element);
        }
      }
    });
  }

  /**
   * ロード処理を再度実行します。history.pushStateを使ったときに呼び出してください。
   */
  static reload() {
    this.bind = null;
    document.querySelectorAll('[data-load-search]').forEach((element) => {
      HaoriLoad.bindSearch(element);
    });
  }

  /**
   * 対象エレメントに対してクリックイベントを発生させます。
   *
   * @param element エレメント
   */
  static fireClick(element: Element) {
    element.dispatchEvent(
      new CustomEvent('click', {
        bubbles: true,
        cancelable: true,
        composed: true,
      })
    );
  }
}

document.querySelectorAll('[data-load-search]').forEach((element) => {
  HaoriLoad.bindSearch(element);
});

document.addEventListener('DOMContentLoaded', () => {
  HaoriLoad.init = true;
  HaoriLoad.clickQueue.forEach((element) => {
    // ロード前にキューに入れたエレメントに対してクリックイベントを発生させる
    HaoriLoad.fireClick(element);
  });
  HaoriLoad.clickQueue = [];

  document.querySelectorAll('[data-load-click]').forEach((element) => {
    HaoriLoad.fireClick(element);
  });
});

document.body.addEventListener('load', (event) => {
  (<HTMLElement>event.target).querySelectorAll('[data-load-search]').forEach((element) => {
    HaoriLoad.bindSearch(element);
  });
  
  (<HTMLElement>event.target).querySelectorAll('[data-load-click]').forEach((element) => {
    HaoriLoad.fireClick(element);
  });
});
